<template>
  <div>

    <body class="snippet-body">
      <div class="container pt-4 pb-3">
        <div class="text-1"></div>
        <div class="text-2"></div>
        <div class="text-3"></div>
        <div class="text-center ">
          <p class="display-7 fw-bold"><img src="@/assets/img/logo.png" alt="logo" class="img-fluid login_logo p-2"></p>
          <div class="d-flex align-items-center justify-content-center mb-2">
            <h2 class="fw-bold mt-0 ">智慧景區管理平台</h2>
          </div>
        </div>

        <form class="needs-validation" @submit.prevent="loginAD">
          <div class="row px-md-4 px-1 m-0">

            <div class="col-12 py-1">
              <div>
                <p class="pb-1 username">帳號</p>
                <input type="text" class="form-control mb-1" placeholder="請輸使用者帳號" v-model="form.username" v-focus
                  required>
              </div>
            </div>
            <div class="col-12 py-1">
              <div>
                <p class="pb-1 username">密碼</p>
                <input type="password" name="pwd" class="form-control mb-1" placeholder="請輸入使用者密碼"
                  v-model="form.password" required>
              </div>
            </div>
            <div class="col-12 create py-1">
              <button type="submit" class="btn btn-success  w-100 py-2">
                <div class="d-flex align-items-center justify-content-between">
                  <p class="fw-semibold text-light">機關AD帳號登入</p>
                  <span class="fas fa-arrow-right "></span>
                </div>
              </button>
            </div>
            <hr class="mt-3 ">
            <div class="col-12 create py-1">
              <button type="button" class="btn btn-primary  w-100 py-2" @click="login">
                <div class="d-flex align-items-center justify-content-between">
                  <p class="fw-semibold text-light">廠商登入</p>
                  <span class="fas fa-arrow-right "></span>
                </div>
              </button>
            </div>

            <div class="d-flex justify-content-between mt-3">
              <div class="text-center py-2" style="align-self: center;"> Copyright © 2023 All Rights Reserved </div>
              <div class="create py-2">
                <!-- <a class="btn btn-dark" :href="signInKeycloakUrl" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                  <div class="align-items-center justify-content-between">
                    <p class="text-light">原登入系統</p>
                  </div>
                </a> -->
              </div>
            </div>

          </div>
        </form>
        <div v-if="loading">
          <loadingIndicator> </loadingIndicator>

        </div>
        <div class="loading-area" v-if="loading">
          <p>登入成功，請稍後 <i class="fas fa-spinner fa-pulse"></i></p>
        </div>
      </div>
    </body>
  </div>

</template>
  
  
  <script>
  import helper from "@/helpers/signInHelper";
  import axios from 'axios'
  import { alertError } from "@/functions";
  import loadingIndicator from "./loadingIndicator";
  
  import VForm from "shared/form";
  
  export default {
    components: { VForm, loadingIndicator },
    data: () => ({
      signInKeycloakUrl: '/api/authentication/sign-in/keycloak?ip=' + window.location.hostname,
      form: {
        username: null,
        password: null,
        rememberMe: false,
      },
      loading: false,
  
    }),
    computed: {
      // logoWidth() {
      //   return window.innerWidth > 500 ? '' : 237;
      // },
    },
    async mounted() {
      await this.$recaptchaLoaded();
      this.$recaptchaInstance.showBadge();
    },
  
  
    methods: {
      async login() {
  
        const token = await this.$recaptcha("login");
        const form = {
          username: this.form.username,
          password: this.form.password,
          rememberMe: false,
        }
        if (window.location.host === "192.168.1.1") { // vpn 改用axios
          await axios.post(`${window.location.href.replace('login', '')}api/authentication/sign-in`, form, { headers: { token: token } }).then((a) => {
            helper.signIn(a.data);
            this.loading = true;
  
          }, (a) => {
            if (a.bodyText !== null && a.bodyText.includes('Invalid login attempt.')) { //使用vpn a.bodyText會是null
              alert('帳號或密碼錯誤')
            } else if (a.bodyText !== null && a.bodyText.includes('User account locked out.')) { //使用vpn a.bodyText會是null
                alert('帳號密碼錯誤五次，帳號鎖定15分鐘。')
            } else {
              alert(Object.values(a.body).map(b => b.join('\n')).join("\n"));
            }
          }
            // alertError  //"@/functions" 函式 
  
          );
  
        } else {
          this.$http.post("/api/authentication/sign-in", form, { headers: { token: token } }).then((a) => {
            helper.signIn(a.body);
            this.loading = true;
          }, (a) => {
            console.log('a', a)
            if (a.bodyText !== null && a.bodyText.includes('Invalid login attempt.')) { //使用vpn a.bodyText會是null
              alert('帳號或密碼錯誤')
            } else if (a.bodyText !== null && a.bodyText.includes('User account locked out.')) { //使用vpn a.bodyText會是null
                alert('帳號密碼錯誤五次，帳號鎖定15分鐘。')
            } else {
              alert(Object.values(a.body).map(b => b.join('\n')).join("\n"));
  
            }
          }
            // alertError  //"@/functions" 函式 
  
          );
  
        }
      },
  
      async loginAD() {
        const token = await this.$recaptcha("login");
        const form = {
          username: this.form.username,
          password: this.form.password,
          rememberMe: false,
        }

        console.log('loginAD')
        this.$http.post("/api/AuthFromLdap/login-LDAP", form, { headers: { token: token } }).then((a) => {
            console.log('loginAD a', a.body)
            helper.signIn(a.body.token);
            this.loading = true;
          }, (a) => {
            console.log('loginAD a', a)
            if (a.bodyText !== null && a.bodyText.includes('Invalid login attempt.')) { //使用vpn a.bodyText會是null
              alert('帳號或密碼錯誤')
            } else if (a.bodyText !== null && a.bodyText.includes('User account locked out.')) { //使用vpn a.bodyText會是null
                alert('帳號密碼錯誤五次，帳號鎖定15分鐘。')
            } else {
              alert(Object.values(a.body).map(b => b.join('\n')).join("\n"));
  
            }
          }
            // alertError  //"@/functions" 函式 
  
          );


      }
  
    },
    mounted() {
      // location.href = this.signInKeycloakUrl
    },
  };
  </script>
  
  <style scoped>
  html {
    overflow-y: unset !important;
  }
  
  body {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #86e1d0;
    overflow-y: hidden;
    z-index: 1;
  }
  
  p {
    margin: 0;
  }
  
  .container {
    max-width: 450px;
    background-color: #ecf4f5;
    margin: auto;
    color: #004a98;
    border-radius: 10px;
    position: relative;
    /* z-index: 999; */
  }
  
  .text-1 {
    position: absolute;
    top: -50px;
    left: -30%;
    width: 250px;
    height: 250px;
    clip-path: circle(50%);
    background-color: #50C7B9;
    z-index: -1;
    opacity: .9
  }
  
  .text-2 {
    position: absolute;
    top: -60px;
    right: -5%;
    width: 80px;
    height: 80px;
    clip-path: circle(50%);
    background-color: #6ECAC0;
    opacity: .9
  }
  
  .text-3 {
    position: absolute;
    bottom: -10px;
    right: -15%;
    width: 100px;
    height: 100px;
    clip-path: circle(50%);
    background-color: #70BFB6;
    z-index: -1;
    opacity: .9
  }
  
  small .btn.btn-primary {
    background-color: transparent;
    border: none;
    color: #26D0CE;
  }
  
  .create .btn.btn-primary {
    width: 100%;
    padding: 0 20px;
    display: block;
    color: white;
    font-size: 18px;
    font-weight: bold;
    background-image: linear-gradient(to right, #1A2980 0%, #51A2D3 51%, #1A2980 100%);
    background-size: 200% auto;
    border: none;
    text-transform: capitalize;
    transition: 0.5s;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .1)
  }
  
  .create .btn.btn-primary:hover {
    background-position: right center;
    color: #fff;
    text-decoration: none;
  }
  
  .create .btn.btn-primary .fas {
    transform: translateX(0px);
    transition: transform 0.5s ease
  }
  
  .create .btn.btn-primary:hover .fas {
    transform: translateX(10px);
    transition: transform 0.5s ease
  }
  
  .create .btn.btn-success {
    width: 100%;
    padding: 0 20px;
    display: block;
    color: white;
    font-size: 18px;
    font-weight: bold;
    background-image: linear-gradient(to right, #00ae9a 0%, #53D3C4 51%, #00ae9a 100%);
    background-size: 200% auto;
    border: none;
    text-transform: capitalize;
    transition: 0.5s;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .1)
  }
  
  .create .btn.btn-success:hover {
    background-position: right center;
    color: #fff;
    text-decoration: none;
  }
  
  .create .btn.btn-success .fas {
    transform: translateX(0px);
    transition: transform 0.5s ease
  }
  
  .create .btn.btn-success:hover .fas {
    transform: translateX(10px);
    transition: transform 0.5s ease
  }

  .create .btn.btn-dark {
    width: 100%;
    padding: 0 20px;
    display: block;
    color: white;
    font-weight: bold;
    background-image: linear-gradient(to right, #216374 0%, #575757 51%, #216374 100%);
    background-size: 200% auto;
    border: none;
    text-transform: capitalize;
    transition: 0.5s;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .1)
  }
  
  .create .btn.btn-dark:hover {
    background-position: right center;
    color: #fff;
    text-decoration: none;
  }
  
  .create .btn.btn-dark .fas {
    transform: translateX(0px);
    transition: transform 0.5s ease
  }
  
  .create .btn.btn-dark:hover .fas {
    transform: translateX(10px);
    transition: transform 0.5s ease
  }
  
  .form-control {
    color: #000;
  
    background-color: #fff;
    border: 2px solid #d7d7d7;
  
    padding-left: 20px;
  }
  
  .form-control:focus {
    color: #000;
    background-color: #fff;
    border: 2px solid #004a98;
    box-shadow: none;
  }
  
  .username {
    font-size: 16px;
    color: #004a98;
    font-weight: bold
  }
  
  ::placeholder {
    font-size: 12px;
    font-weight: 600;
  }
  
  hr {
    border-top: 1px solid #004a98 !important;
    /* height: 1em; */
    text-align: center;
    width: 93% !important;
    margin: 0px auto;
    overflow: visible;
    opacity: 1;
    margin-bottom: 1em;
  }
  
  hr::after {
    content: "或";
    background: #ecf4f5;
    color: #004a98;
    display: inline-block;
    height: 2em;
    line-height: 2em;
    position: relative;
    top: -1em;
    padding: 0 1em;
  
  
  }
  
  @media(max-width:930px) {
    .text-1 {
      display: none;
    }
  
    .text-2 {
      z-index: -1;
    }
  
  }
  
  .login_logo {
    width: 334px;
    height: auto;
    margin-top: 0px;
  
  
  }
  </style>
  